/**
 * Add a is-pinned class when the cart sticky button gets pinned
 */
document.addEventListener('DOMContentLoaded', function () {
  const stickyButton = document.querySelector('[data-cart-sticky-button]');
  const observer = new IntersectionObserver(
    ([event]) => {
      event.target.classList.toggle('is-pinned', event.intersectionRatio < 1);
    },
    { threshold: [1] }
  );

  observer.observe(stickyButton);
});
